import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageRefreshService {
  private readonly refreshSource = new Subject<string>();

  requestRefresh(menuRef: string | null | undefined): void {
    const normalizedRef = this.normalizeRef(menuRef);
    if (!normalizedRef) {
      return;
    }

    this.refreshSource.next(normalizedRef);
  }

  onMenuRefresh(menuRefs: string | string[]): Observable<string> {
    const expectedRefs = new Set(
      (Array.isArray(menuRefs) ? menuRefs : [menuRefs])
        .map((menuRef) => this.normalizeRef(menuRef))
        .filter((menuRef): menuRef is string => !!menuRef),
    );

    return this.refreshSource.asObservable().pipe(
      filter((menuRef) => expectedRefs.has(menuRef)),
    );
  }

  private normalizeRef(menuRef: string | null | undefined): string {
    return (menuRef ?? '').trim();
  }
}